export const USER_ROLE_VALUES = {
  WHISTLE_BLOWER: 1,
  TENANT_USER: 2,
  TENANT_ADMIN: 3,
  EXTERNAL_USER: 5,
  PARTNER_USER: 6,
  PARTNER_ADMIN: 7,
} as const;
export type UserRole = keyof typeof USER_ROLE_VALUES;
export const getUserTypeName = (id: number) => {
  const userType = Object.entries(USER_ROLE_VALUES).find(
    (entry) => entry[1] === id,
  )?.[0];
  if (userType) {
    return userType as UserRole;
  }
  return null;
};

export const ROLE_LABEL_MAP: Record<UserRole, string> = {
  TENANT_ADMIN: 'Admin',
  TENANT_USER: 'User',
  EXTERNAL_USER: 'External User',
  PARTNER_ADMIN: 'Admin',
  PARTNER_USER: 'Partner',
  WHISTLE_BLOWER: 'User',
};
